export function emitFirestoreError(payload) {
  try {
    const detail = {
      code: payload?.code || "unknown",
      message: payload?.message || "Operation failed",
      operation: payload?.operation || "",
      retry: payload?.retry || null,
      ts: Date.now(),
    };
    window.dispatchEvent(new CustomEvent("fs-error", { detail }));
  } catch {
    // ignore
  }
}
